<app-project-list-nudge (closeNudge)="onClose()" (click)="openDialog()" icon="archive">
	<div class="project-nudge-content">
		<div
			class="nudge-explanation"
			[innerHTML]="'project-archivation-dialog.nudge.title' | translate: { numberOfProjects: (relevantProjects$ | async).length }"
		></div>
		<div class="text-decoration-underline pt- 1">{{ 'project-archivation-dialog.nudge.show-all' | translate }}</div>
	</div>
</app-project-list-nudge>
